import Vue from 'vue'
import moment from 'moment'
import * as utils from './helpers/utilHelper'

Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('YYYY-MM-DD')
  }
})

Vue.filter('formatPrice', function(value) {
  if (value) {
    return utils.modifyPriceForDisplay(value)
  } else {
    return '0,00'
  }
})
